import request from '../config/network/requestUcenterApiService'
// import request2 from '../config/network/requestMockApiService'
import Config from '../config/app'

// 获取校区列表
export function getSchool () {
  return request({
    url: 'api/school',
    method: 'get'
  })
}

// 获取cocos最新包预览地址
export function getPackLast() {
  return request({
    url: 'api/app-packet/cocos/last',
    method: 'get'
  })
}

// 获取权限
export function getPermissions ({ url }) {
  return request({
    url,
    method: 'get'
  })
}

// 获取权限 - 个人
export function getPermissionsByUser () {
  return request({
    url:`api/users/me`,
    method: 'get'
  })
}

/**
 * 阿里云语音合成
 * @param work  string	合成文本。最大字数不超过128个
 * @param voice string	发音人
 * @param volume  int	音量，范围是0~100，默认50
 * @param speech_rate  int	语速，范围是-500~500，默认是0
 */
export function getVoiceByAliyun({
   work,
   voice,
   volume,
   speech_rate
}) {
  return request({
    url:`api/audio-synthesis/cloud`,
    method: 'get',
    params: {
      work,
      voice,
      volume,
      speech_rate
    }
  })

}

// 导入PPT
export function importPPT ({
 clientsId,
 name,
 url,
 etag,
 result_id,
 source,
 options
}) {
  return request({
    url: `https://tool.ucenter.${Config.ppt_web || Config.domain}/api/service/ppt2h5`,
    method: 'post',
    data: {
      clients_id: clientsId,
      name,
      'attributes[remotepath]': url,
      'attributes[md5]': etag,
      result_id,
      source,
      options
    }
  })
}

// 获取ppt
export function getPPTStatus ({
 id,
 result_id,
 source
}) {
  return request({
    url: `https://ucenter.${Config.ppt_web || Config.domain}/api/service/ppt2h5/${id}`,
    method: 'get',
    params: {
      result_id,
      source
    }
  })
}

// 获取ppt
export function getHeatBeat ({
 result_id,
 source,
 user_id,
 course_auth_token
}) {
  return request({
    url: `api/socket/heart-beat/${result_id}`,
    method: 'get',
    params: {
      source,
      user_id,
      course_auth_token
    }
  })
}

// 获取Cocos包列表
export function getCocosPackList ({
  version,
  sort,
  versionOrder,
}) {
  const params = {}
  if(version) params['like[version]'] = version
  if(sort) params['order[sort]'] = sort === 'asc'?'asc':'desc'
  if(versionOrder) params['order[sort]'] = versionOrder === 'asc'?'asc':'desc'
  return request({
    url: `api/app-pack/cocos-list?per_page=99`,
    method: 'get',
    params
  })
}

